const FLAG_TRUE_VALUES = new Set([true, 1, "1", "true", "TRUE", "si", "SI", "yes", "YES"]);

const pickFirstValue = (source, keys) => {
    if (!source) return undefined;
    for (const key of keys) {
        if (source[key] !== undefined && source[key] !== null && source[key] !== "") {
            return source[key];
        }
    }
    return undefined;
};

export const isTruthyFlag = (value) => FLAG_TRUE_VALUES.has(value);

export const getAuxiliarNombreCompleto = (auxiliar = {}) => {
    const nombre = pickFirstValue(auxiliar, ["nombre", "nombreAuxiliar", "auxiliarNombre"]) || "";
    const apellidoPaterno = pickFirstValue(auxiliar, ["apellidoPaterno", "apellido_paterno"]) || "";
    const apellidoMaterno = pickFirstValue(auxiliar, ["apellidoMaterno", "apellido_materno"]) || "";

    return [nombre, apellidoPaterno, apellidoMaterno]
        .filter(Boolean)
        .join(" ")
        .replace(/\s+/g, " ")
        .trim();
};

export const isNoEnviarRecordActive = (record = {}) => {
    const explicitState = pickFirstValue(record, ["activo", "active", "vigente", "estado_activo"]);
    if (explicitState !== undefined) {
        return isTruthyFlag(explicitState);
    }

    const textualState = pickFirstValue(record, ["estado", "status"]);
    if (textualState !== undefined) {
        return ["activo", "active", "vigente", "1"].includes(String(textualState).toLowerCase());
    }

    const deletionDate = pickFirstValue(record, [
        "fecha_eliminacion",
        "fechaEliminacion",
        "deleted_at",
        "deletedAt",
    ]);

    return !deletionDate;
};

export const getNoEnviarPacienteHistory = (source = {}) => {
    const history = pickFirstValue(source, [
        "no_enviar_historial",
        "noEnviarHistorial",
        "no_enviar_paciente_historial",
        "noEnviarPacienteHistorial",
        "restricciones_no_enviar",
        "restriccionesNoEnviar",
        "historial_no_enviar",
        "historialNoEnviar",
    ]);

    return Array.isArray(history) ? history : [];
};

export const getNoEnviarPacienteStatus = (source = {}) => {
    const history = getNoEnviarPacienteHistory(source);
    const activeRecord = history.find(isNoEnviarRecordActive);

    const activeFlag = pickFirstValue(source, [
        "no_enviar_activo",
        "noEnviarActivo",
        "no_enviar_paciente",
        "noEnviarPaciente",
        "bloqueado_no_enviar",
        "bloqueadoNoEnviar",
        "restriccion_no_enviar",
        "restriccionNoEnviar",
    ]);

    const active = activeRecord ? true : isTruthyFlag(activeFlag);

    return {
        active,
        id: pickFirstValue(source, ["no_enviar_id", "noEnviarId"]) ?? activeRecord?.id ?? null,
        observation:
            pickFirstValue(source, [
                "no_enviar_observacion",
                "noEnviarObservacion",
                "observacion_no_enviar",
                "observacionNoEnviar",
            ]) ??
            activeRecord?.observacion ??
            activeRecord?.observation ??
            "",
        date:
            pickFirstValue(source, [
                "no_enviar_fecha",
                "noEnviarFecha",
                "fecha_no_enviar",
                "fechaNoEnviar",
            ]) ??
            activeRecord?.fecha_registro ??
            activeRecord?.fecha ??
            activeRecord?.date ??
            null,
        history,
    };
};

const normalizeDateOnly = (value) => {
    if (!value) return null;

    if (value instanceof Date && !Number.isNaN(value.getTime())) {
        return value.toISOString().slice(0, 10);
    }

    const raw = String(value).trim();
    if (!raw) return null;

    const isoMatch = raw.match(/\d{4}-\d{2}-\d{2}/);
    if (isoMatch) {
        return isoMatch[0];
    }

    return null;
};

export const isNoEnviarPacienteActiveOnDate = (source = {}, targetDate) => {
    const status = getNoEnviarPacienteStatus(source);

    if (!status.active) {
        return false;
    }

    const sinceDate = normalizeDateOnly(status.date);
    const compareDate = normalizeDateOnly(targetDate);

    if (!sinceDate || !compareDate) {
        return status.active;
    }

    return compareDate >= sinceDate;
};

export const formatAuxiliarSearchLabel = (
    auxiliar = {},
    { includeRut = true, includeNoEnviarSuffix = false } = {}
) => {
    const nombre = getAuxiliarNombreCompleto(auxiliar) || "Auxiliar";
    const rut = pickFirstValue(auxiliar, ["rut", "auxiliarRut"]);
    const status = getNoEnviarPacienteStatus(auxiliar);

    let label = nombre;
    if (includeRut && rut) {
        label += ` (${rut})`;
    }

    if (includeNoEnviarSuffix && status.active) {
        label += " - NO ENVIAR A ESTE DOMICILIO";
    }

    return label;
};

export const buildNoEnviarWarningMessage = ({ auxiliar, pacienteNombre = "" }) => {
    const status = getNoEnviarPacienteStatus(auxiliar);
    const nombreAuxiliar = getAuxiliarNombreCompleto(auxiliar) || "El auxiliar";

    let message = `${nombreAuxiliar} esta marcado como NO ENVIAR A ESTE DOMICILIO`;
    if (pacienteNombre) {
        message += ` para ${pacienteNombre}`;
    } else {
        message += " para este paciente";
    }

    if (status.observation) {
        message += `. Obs: ${status.observation}`;
    }

    return message;
};
